import { Injectable } from '@angular/core';
import { EchartsGaugeGraph } from '../../class/echarts-gauge-graph';
import { EchartsGraph } from '../../class/echarts-graph';
import { EchartsPieGraph } from '../../class/echarts-pie-graph';
import { EchartsGraphConfig } from '../../type/EchartGraphConfig';

/**
 * Echarts Builder
 * Provide tools to generate an echart options ready to be provided to an echart renderer
 */
@Injectable({
  providedIn: 'root'
})
export class EchartsBuilderService {

  constructor() {}

  buildSimpleGraph(config: EchartsGraphConfig): EchartsGraph {
    return new EchartsGraph(config);
  }

  buildPieGraph(config: EchartsGraphConfig): EchartsPieGraph {
    return new EchartsPieGraph(config);
  }

  buildGaugeGraph(config: EchartsGraphConfig): EchartsGaugeGraph {
    return new EchartsGaugeGraph(config);
  }
}
